import {useVisualizerSession} from "../../visualizer/VscVisualizerSession";
import IVscCommunityMapInfo from "../../../visualizers/IVscCommunityMapInfo";
import React, {useState} from "react";
import SiteSpecificInfo from "./SiteSpecificInfo";
import {ISlsOrd} from "../../../kova/slsordClient";

import {IModelConfig} from "../../../data/IViewpoint";

export interface IFindYourHomeAdmin {
    activeCamera?: string

    modelConfig:IModelConfig;
    slsOrd: ISlsOrd;
}



const SiteSpecificAdmin: React.FC<IFindYourHomeAdmin> = (props) => {


    const { slsOrd, modelConfig } = props;

    const screenprops = [
        ["Active Camera", props.activeCamera ?? "none"],
        [ "Lot ID", slsOrd.unrealId],
        [ "Plan ID", slsOrd.modelId],
        [ "Marketing Name", slsOrd.marketingName],
        [ "Street Address", slsOrd.lotStreetAddress],
        [ "SlsOrdRID", slsOrd.id],
        [ "LotRID", slsOrd.lotId]
    ];
    const visualizerSession = useVisualizerSession();

    const [mapInfo, setMapInfo] = useState<IVscCommunityMapInfo|null>(null);
    const loadMapInfo = async () => {
        const mapInfoResponse = await visualizerSession.requestMapInfo();

        setMapInfo(mapInfoResponse);
    }

    return <main>
        <h1>Vsc Admin / SiteSpecific</h1>

        <table>
            <tr>
                <th>Property</th>
                <th>Value</th>
            </tr>
            { screenprops.map((prop) => <tr>
                <td>{ prop[0] }</td>
                <td>{ prop[1] }</td>
            </tr>)
            }
        </table>

        <button onClick={() => loadMapInfo()}>Load map info</button>
        { mapInfo && <SiteSpecificInfo mapInfo={mapInfo} slsOrd={slsOrd} modelConfig={modelConfig} />}
    </main>

}
export default SiteSpecificAdmin;